<template>
    <p class="text-xl font-bold mb-10 sm:mb-15 md:mb-20 lg:mb-30 xl:mb-40 2xl:mb-50"><slot></slot></p>
</template>